import API from "shared/services/Api";
import { IEvolution } from "shared/types/Evolution";

export const getEvolutions = async (data: IEvolution) =>
  API.get(`oc/evolution?id=${data.userId}&idPatient=${data.idPac}`);
